module.exports = __webpack_public_path__ + "static/media/OCR文字识别.df3bdc4e.png";